/**
 * Tokens de la 2.0 = la paleta de la 1.0 (decisión de Gabor, 13/10): mismos valores HSL que
 * `src/index.css` de C:\DEV\nuvvu (shadcn: primary coral `12 90% 62%`, radio 0.75rem, Inter).
 * El rediseño (sección 12) podrá cambiar formas y espaciados, pero los colores se mantienen.
 * Nada en apps/ usa valores literales: solo estos nombres.
 */
export const tokens = {
  color: {
    bg: 'var(--nv-bg)',
    fg: 'var(--nv-fg)',
    card: 'var(--nv-card)',
    primary: 'var(--nv-primary)',
    primaryFg: 'var(--nv-primary-fg)',
    secondary: 'var(--nv-secondary)',
    accent: 'var(--nv-accent)',
    accentFg: 'var(--nv-accent-fg)',
    muted: 'var(--nv-muted)',
    border: 'var(--nv-border)',
    danger: 'var(--nv-danger)',
    success: 'var(--nv-success)',
    sandbox: 'var(--nv-sandbox)',
  },
  radius: { sm: '8px', md: '10px', lg: '12px', xl: '16px', pill: '999px' },
  space: { 1: '4px', 2: '8px', 3: '12px', 4: '16px', 6: '24px', 8: '32px' },
  font: { body: 'var(--nv-font-body)', display: 'var(--nv-font-display)' },
} as const;

/** CSS base con las variables en claro/oscuro (valores de la 1.0); se importa una vez en cada app. */
export const baseCss = `
@import url('https://fonts.googleapis.com/css2?family=Inter:wght@400;500;600;700;800&display=swap');
:root{
  --nv-bg:hsl(0 0% 99%);--nv-fg:hsl(220 20% 10%);--nv-card:hsl(0 0% 100%);
  --nv-primary:hsl(12 90% 62%);--nv-primary-fg:hsl(0 0% 100%);
  --nv-secondary:hsl(220 14% 96%);--nv-accent:hsl(12 90% 96%);--nv-accent-fg:hsl(12 90% 40%);
  --nv-muted:hsl(220 10% 46%);--nv-border:hsl(220 13% 91%);
  --nv-danger:hsl(0 84% 60%);--nv-success:hsl(160 60% 40%);--nv-sandbox:#f59e0b;
  --nv-font-body:'Inter',system-ui,sans-serif;--nv-font-display:'Inter',system-ui,sans-serif;
  color-scheme:light dark
}
@media (prefers-color-scheme: dark){:root:not([data-theme="light"]){
  --nv-bg:hsl(220 20% 6%);--nv-fg:hsl(0 0% 95%);--nv-card:hsl(220 20% 9%);
  --nv-secondary:hsl(220 14% 14%);--nv-accent:hsl(12 50% 15%);--nv-accent-fg:hsl(12 90% 70%);
  --nv-muted:hsl(220 10% 55%);--nv-border:hsl(220 14% 16%);--nv-danger:hsl(0 62% 50%)
}}
:root[data-theme="dark"]{
  --nv-bg:hsl(220 20% 6%);--nv-fg:hsl(0 0% 95%);--nv-card:hsl(220 20% 9%);
  --nv-secondary:hsl(220 14% 14%);--nv-accent:hsl(12 50% 15%);--nv-accent-fg:hsl(12 90% 70%);
  --nv-muted:hsl(220 10% 55%);--nv-border:hsl(220 14% 16%);--nv-danger:hsl(0 62% 50%)
}
html,body{margin:0;background:var(--nv-bg);color:var(--nv-fg);font-family:var(--nv-font-body);min-height:100dvh;-webkit-text-size-adjust:100%}
body{padding-bottom:env(safe-area-inset-bottom)}
button,input{font:inherit}
input,select,textarea{font-size:16px}
dialog::backdrop{background:rgba(0,0,0,.45)}
`;
